import { useApplicantAPI } from "@certn/api/src/useApplicantAPI";
import {
  GridItem,
  TextAreaFormikField,
  Text,
  Grid,
  Link,
} from "@certn/cascadia-react";
import { css } from "@emotion/css";
import { Field, useField } from "formik";
import { Trans, useTranslation } from "react-i18next";

import { buildDescription } from "./helpers";
import { FileUploadField } from "../../../../components/upload/FileUploadField";
import { baseFileTypes } from "../../../../utils/file-types";
import { FormModal } from "../FormModal";

type RequestDetailsModalProps = {
  onSubmit: () => void;
  onBack: () => void;
  onClose: () => void;
};

export function RequestDetailsModal({
  onSubmit,
  onBack,
  onClose,
}: RequestDetailsModalProps) {
  const { t } = useTranslation();
  const [requestTypeFields] = useField("request_types");
  const { data: requestTypes } = useApplicantAPI(
    "/api/internal/applicant/request-account-data/options/"
  );

  return (
    <FormModal
      title={t("Personal data request")}
      onSubmit={onSubmit}
      onCancel={onBack}
      onClose={onClose}
      continueText={t("Submit request")}
      secondaryText={t("Back")}
      variant="success"
    >
      <Grid form>
        <GridItem className={css({ flexDirection: "row" })}>
          <Text>
            <Text style="global/heading-medium">
              <Trans>Request type</Trans>:
            </Text>{" "}
            <Text style="global/body-primary">
              {buildDescription(requestTypeFields.value, requestTypes)}
            </Text>
          </Text>
        </GridItem>

        <GridItem>
          <Field
            as={TextAreaFormikField}
            label={t("Request details")}
            name="request_details"
            isRequired
            testID="request-data-modal-request-details-input"
          />
        </GridItem>

        <GridItem>
          <Field
            name="supporting_documents"
            as={FileUploadField}
            color="border-strong"
            size="desktop"
            label={t("Supporting documents")}
            fileTypes={baseFileTypes}
            maxSizeBytes={10000000}
            multiple
            testID="request-data-modal-document-upload-button"
          />
        </GridItem>

        <GridItem>
          <Text color="text-weak">
            <Trans>
              For any questions and additional information on your privacy
              request, please contact{" "}
              <Link
                testID="privacy-email"
                target="_blank"
                textStyle="global/body-secondary"
                textColor="text-weak"
                href="mailto: privacy@certn.co"
              >
                privacy@certn.co
              </Link>
              . Consumers may also contact Certn at +1 (844) 987 0690 for
              additional assistance.
            </Trans>
          </Text>
        </GridItem>
      </Grid>
    </FormModal>
  );
}
